import React, { useState } from 'react';
import {

Select,
MenuItem,
FormControl,
InputLabel,
SelectChangeEvent,
FormHelperText,
} from '@mui/material';

interface CustomMUISelectProps {
label?: string;
value: string;
onChange: (event: SelectChangeEvent) => void;
options: { label: string; value: string; key: number | string }[];
error?: boolean;
helperText?: string;
disabled?: boolean;
fullWidth?: boolean;
}

const CustomMUISelect: React.FC<CustomMUISelectProps> = ({
label,
value,
onChange,
options,
error = false,
helperText,
disabled = false,
fullWidth = false,
}) => {
return (
    <FormControl fullWidth={fullWidth} error={error}>
        {label && <InputLabel>{label}</InputLabel>}
        <Select 
            value={value} 
            onChange={onChange}
            label={label}
            size='small'
            sx={{
                backgroundColor: 'var(--input-bg)',
                color: 'var(--text-color)',
                fontSize: '.7rem',
                borderColor: 'var(--input-border)',
                borderRadius: '15px',
                '& .MuiSelect-select': {
                paddingTop: '6px',
                paddingBottom: '6px',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                borderColor: 'var(--input-border)',
                },
                width: '84px',
                textAlign: 'center',
            }}
            IconComponent={() => null}
            slotProps={{
                input: {
                sx: {
                    pr: '14px !important' 
                }
                }
            }}
            MenuProps={{
                PaperProps: { sx: {
                    bgcolor: "var(--input-bg)",
                    color: "var(--text-color)",
                    borderRadius: "15px",
                }},
            }}
            disabled={disabled}
        >
            {options.map((option) => (
                <MenuItem 
                    key={option.key} 
                    value={option.value} 
                    sx={{
                        fontSize: '.7rem',
                    }}
                >
                    {option.label}
                </MenuItem>
            ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
);
};

export default CustomMUISelect;